<div
  class="pt-2 pt-md-3 pt-xl-2 mb-0 pb-4 mb-md-5 mb-xl-0 pb-md-5 pb-xl-0 mx-auto px-lg-0"
>
  <div class="global-container container col-12">
    <div class="row">
      <div class="thunder-col-3 col-6 mb-4">
        <div class="sm-card-3 card shadow py-0">
          <div class="card-body my-1 py-2">
            <div class="row">
              <div class="col mx-0 px-0 mx-sm-2 mx-md-0 mx-lg-2">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-3">total Stations</span>
                </div>
                <div class="row">
                  <div class="col-auto ml-sm-2 ml-md-0 ml-lg-2">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-1 pl-lg-3 pb-0">{{
                        totals.stations
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline mr-1 pr-1">
                <i class="fas fa-gas-pump text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="thunder-col-3 col-6 mb-4">
        <div class="sm-card-4 card shadow py-0">
          <div class="card-body my-1 py-2">
            <div class="row">
              <div class="col mx-0 px-0 mx-sm-2 mx-md-0 mx-lg-2">
                <div class="text-uppercase text-gray font-weight-bold mb-1">
                  <span class="sm-card-title-4">total clients</span>
                </div>
                <div class="row">
                  <div class="col-auto ml-sm-2 ml-md-0 ml-lg-2">
                    <div class="text-primary font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-1 pl-lg-3 pb-0">{{
                        totals.clients
                        }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-auto align-self-baseline mr-1 pr-1">
                <i class="fas fa-users text-secondary"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="global-container container mt-2 mt-md-3 mb-1 mb-xl-0 mx-0 shadow-lg col-12"
    >
      <div class="row">
        <div class="col-12">
          <h2 class="rub-head4 text-info text-center font-weight-bold py-1">
            Today's Status
          </h2>
        </div>
      </div>
    </div>
    <div class="components row mt-2 mt-xl-0 pt-0 mb-2 pb-1">
      <div class="col-12 col-sm-6">
        <div class="big-card-1 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3"
                  >total no. of stages at the station</span
                  >
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <app-stages [stages]="{boda: totals?.stages?.boda, taxi: totals?.stages?.taxi}"></app-stages>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6">
        <div class="big-card-1 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total no. of clients who took loans</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{totals?.clientsBorrowed}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-1 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3"
                  >total new registered clients</span
                  >
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{ totals.clients }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-1 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total no. of clients who saved</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{totals?.clientsSaved}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-1 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-1 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total no. of clients who paid</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <span class="pl-3 pb-0">{{totals?.clientsPaid}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="global-container container mt-2 mt-md-3 mb-2 mb-xl-0 mx-0 shadow-lg col-12"
    >
      <div class="row">
        <div class="col-12">
          <h3 class="rub-head4 text-info text-center font-weight-bold py-1">
            Recovery/Enforcement
          </h3>
        </div>
      </div>
    </div>
    <div class="components row mt-2 mt-xl-0 pt-0">
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-3 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-3 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col mb-2">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total no. of defaulters</span>
                </div>
                <app-products [products]="{boda: totals?.bodaDefaulters, taxi: totals?.taxiDefaulters, micro: totals?.microDefaulters}" currency="false"></app-products>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-3 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-3 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col mb-2">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total no. of Enforcements</span>
                </div>
                <app-products [products]="{boda: totals?.bodaEnforcement, taxi: totals?.taxiEnforcement, micro: totals?.microEnforcement}" currency="false"></app-products>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-12 col-sm-6 col-lg-4">
        <div class="big-card-3 card shadow-lg mt-0 mt-md-1 mb-3 pb-0">
          <div class="big-card-body-3 card-body px-auto my-0 pt-2 pb-0">
            <div class="row">
              <div class="col mb-2">
                <div class="text-uppercase text-primary font-weight-bold mb-1">
                  <span class="sm-card-title-3">total amount recovered</span>
                </div>
                <div class="row">
                  <div class="col-auto">
                    <div class="text-info font-weight-bold h5 mb-0 pb-0">
                      <!--                      <span class="pl-3 pb-0">{{totals?.amountRecovered | number}}</span>-->
                    </div>
                  </div>
                </div>
                <app-products [products]="{boda: totals?.bodaRecovery, taxi: totals?.taxiRecovery, micro: totals?.microRecovery}" currency="true"></app-products>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
